<template>
  <DSButton
    :data-cy="dataCy"
    :variant="variant"
    :disabled="disabled"
  >
    {{ dayLabel }}
  </DSButton>
</template>

<script setup lang="ts">
import { computed } from "vue";
import dayjs from "dayjs";
import DSButton from "@/src/design_system/button_and_controls/button/components/DSButton.vue";
import type { DSDateTimePickerModelValue } from "@/src/design_system/form_elements/shared/types/dateTimePicker";

type Props = {
  date: Date;
  dayLabel: number | string;
  disabled: boolean;
  selectedDate: DSDateTimePickerModelValue;
};

const props = defineProps<Props>();

const dataCy = computed(() => `ds-datepicker__day-button--${props.date.toLocaleDateString("en-CA")}`);

const isSelectedDay = computed(() => {
  if (!props.selectedDate) return false;

  return dayjs(props.date).isSame(props.selectedDate, "day");
});

const isToday = computed(() => dayjs(props.date).isSame(dayjs(), "day"));

const variant = computed(() => {
  if (isSelectedDay.value) return "primary";
  if (isToday.value) return "secondary";

  return "ghost";
});
</script>
